import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import EventPriceOptionsModal from '../../Common/EventPriceOptionsModal/EventPriceOptionsModal';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from '../../Cart/locales/en.json';
import fr from '../../Cart/locales/fr.json';
import '../../Cart/Cart.css';
import './MobileBasketSummary.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class MobileBasketSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEventPriceOptionsOpen: false,
            pricingOptions: [],
            currentPrice: {}
        }
    }

    triggerPriceChangeFlow = async (ticket) => {
        const {
            event_date_id,
            section_id,
            pricing_option_id
        } = ticket;
        const query = this.props.user.role ? `/box-office/pricing-options` : `/tickets/pricing-options`;

        try {
            const response = await ApiRequest(`${query}?event_date_id=${event_date_id}&section_id=${section_id}`);
            console.log('Get Pricing Options Response: ', response);
            this.setState({
                pricingOptions: response.data.pricing_options,
                currentPrice: response.data.pricing_options.find(price => price.id === pricing_option_id),
                ticket
            });
        } catch (error) {
            console.log(error);
        }

        this.toggleEventPriceOption();
    }

    handlePriceChange = (e) => {
        let id = e.target.value;
        let currentPrice = {
            ...this.state.currentPrice
        };
        this.state.pricingOptions.forEach((price) => {
            if (price.id === parseInt(id, 0)) {
                currentPrice = price;
            }
        });

        this.setState(
            {
                currentPrice
            },
            () => {
                this.confirmEventPriceOption();
            }
        );
    }

    addPropsToCurrentPrice = (currentPrice) => {
        const {
            event_date_id,
            section_id,
            row_id,
            seat_id
        } = this.state.ticket;

        const newCurrentPrice = {
            ...currentPrice
        };

        newCurrentPrice.pricing_option_id = newCurrentPrice.id;
        newCurrentPrice.event_date_id = event_date_id;
        newCurrentPrice.section_id = section_id;
        newCurrentPrice.row_id = row_id;
        newCurrentPrice.seat_id = seat_id;

        return newCurrentPrice;
    }

    confirmEventPriceOption = async () => {
        this.props.updateTicketsInCart(this.addPropsToCurrentPrice(this.state.currentPrice), 'reserved', this.state.ticket.id);

        this.setState({
            isEventPriceOptionsOpen: false
        });
    }

    toggleEventPriceOption = () => {
        this.setState({
            isEventPriceOptionsOpen: !this.state.isEventPriceOptionsOpen
        });
    }

    editTicket = (key, parentKey) => {
        this.props.onEditTicket(key, parentKey);
    }

    render() {
        let feesString = '';
        if (this.props.cartPricing) {
            if (this.props.cartPricing.client_fees_detail) {
                if (this.props.cartPricing.client_fees_detail.length > 0) {
                    this.props.cartPricing.client_fees_detail.forEach((fee) => {
                        feesString += `${fee.desc} : ${new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    }).format(fee.amount)} <br />`;
                    });
                }
            }
        }

        return (
            <React.Fragment>
                <EventPriceOptionsModal
                    isEventPriceOptionsOpen={this.state.isEventPriceOptionsOpen}
                    toggleEventPriceOption={this.toggleEventPriceOption}
                    confirmEventPriceOption={this.confirmEventPriceOption}
                    pricingOptions={this.state.pricingOptions}
                    currentPrice={this.state.currentPrice}
                    handlePriceChange={this.handlePriceChange}
                    user={this.props.user}
                />
                {(this.props.cartItems.length > 0 || this.props.cartPricing.donation > 0) &&
                    <div className="showtix-cart__body basket-summary my-4">
                    <h3 className="showtix-cart__title">{strings.cartSummary}</h3>
                    {
                        this.props.cartItems.map((cartItem, i) => {
                            return (
                                <div key={i} className="showtix-cart-item">
                                    <div className="showtix-cart-item__header d-flex">
                                        <div className="showtix-cart-item__poster">
                                            {cartItem[0].poster_graphic_url ?
                                                <img src={cartItem[0].poster_graphic_url} alt={cartItem[0].name} />
                                                :
                                                (cartItem[0].type === "flexpass" ?
                                                    <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} key={0} alt={cartItem[0].name} />
                                                    :
                                                    <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} key={1} alt={cartItem[0].name} />
                                                )
                                            }
                                        </div>
                                        <div className="showtix-cart-item__infos">
                                            <h3 className="showtix-cart-item__title">{cartItem[0].name}</h3>
                                            {(cartItem[0].type !== 'flexpass' && cartItem[0].event_type !== 'V') &&
                                                <p className="showtix-cart-item__date">
                                                    {moment(cartItem[0].event_datetime_local.substring(0, 19)).format('LLLL')}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                    <div className="showtix-cart-item__body">
                                        {
                                            cartItem.map((ticket, j) => {
                                                const full_seat_name = ticket.full_seat_name === '' ? ticket.desc : ticket.full_seat_name;
                                                if (!ticket.social_distance) {
                                                    return (
                                                        <div key={j} className="showtix-cart-item-ticket summary">
                                                            <div className="showtix-badge showtix-background__grey-3">
                                                                {(() => {
                                                                    switch (ticket.type) {
                                                                        case 'general-admission': return strings.generalAdmission;
                                                                        case 'reserved': return strings.reservedSeating;
                                                                        case 'flexpass': return strings.flexpass;
                                                                        default: return strings.generalAdmission;
                                                                    }
                                                                })()}
                                                            </div>
                                                            <span
                                                                className="showtix-cart-item-ticket__name"
                                                                onClick={() => this.triggerPriceChangeFlow(ticket)}
                                                                >
                                                                {ticket.type === 'reserved' ? full_seat_name : ticket.desc} - {new Intl.NumberFormat('en-US', {
                                                                    style: 'currency',
                                                                    currency: 'USD'
                                                                }).format(ticket.amount)}     
                                                            </span>
                                                            <span
                                                                className="showtix-cart-item-ticket__edit"
                                                                onClick={() => this.props.deleteFromCart(ticket)}
                                                            >
                                                                X
                                                            </span>
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }

                    {this.props.cartPricing.donation > 0 &&
                        <div className="showtix-cart-item">
                            <div className="showtix-cart-item__body">
                                <div className="showtix-cart-item-ticket">
                                    DONATION
                                    -&nbsp;
                                                {new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    }).format(this.props.cartPricing.donation)}
                                    <span
                                        className="showtix-cart-item-ticket__edit"
                                        onClick={() => this.props.clearDonationFromCart()}
                                    >X</span>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="showtix-cart-calc">
                        <div className="showtix-cart-calc-item">
                            {this.props.totalItemsInCart} {this.props.totalItemsInCart === 1 ? strings.totalItem : strings.totalItems}
                        </div>

                        {this.props.cartPricing.gross_coupon_discount > 0 &&
                            <div className="showtix-cart-calc-item is-promo">
                                DISCOUNT
                                            <span className="showtix-cart-calc-item__total">
                                    -{
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        }).format(this.props.cartPricing.gross_coupon_discount)
                                    }
                                </span>
                            </div>
                        }


                        {this.props.cartPricing.st4u_fees > 0 &&
                            this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron' &&
                            <div className="showtix-cart-calc-item">
                                {strings.showtixFees}
                                <span className="showtix-cart-calc-item__total">
                                    {
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        }).format(this.props.cartPricing.st4u_fees)
                                    }
                                </span>
                            </div>
                        }

                        {this.props.cartPricing.client_fees > 0 &&
                            this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron' &&
                            <div className="showtix-cart-calc-item">
                                {strings.miscFees}
                                <span href="#" id="tooltip-fees" className="showtix-tooltip" data-tip={feesString} data-html={true}>!</span>
                                <ReactTooltip html={true} />

                                <span className="showtix-cart-calc-item__total">
                                    {
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        }).format(this.props.cartPricing.client_fees)
                                    }
                                </span>
                            </div>
                        }
                    </div>

                    <div className="showtix-cart-total">
                        <div className="showtix-cart-total-item">
                            {strings.total}
                            <span className="showtix-cart-total-item__total">
                                {this.props.billing.method !== 'reserved' && this.props.billing.method !== 'vipatron' ?
                                    new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    }).format(this.props.cartPricing.txn_gross)
                                    :
                                    new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    }).format(this.props.cartItems.reduce((grandTotal, cartItem) => grandTotal + cartItem.reduce((total, ticket) => total + ticket.amount, 0), 0))
                                }
                            </span>
                        </div>
                    </div>
                </div>
                }
            </React.Fragment>
        );
    }
};

export default MobileBasketSummary;



// WEBPACK FOOTER //
// ./src/components/Common/MobileBasketSummary/MobileBasketSummary.js